module.exports = __webpack_public_path__ + "static/media/1.b9e5bcae.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/intro/mobile/1.png
// module id = 2501
// module chunks = 0